import React from 'react';
import MainZone from 'common/components/ui/zones/MainZone';
import ExternalPasswordChangeManager from './containers/ExternalPasswordChangeManager';

export default () => (
    <MainZone>
        <ExternalPasswordChangeManager />
    </MainZone>
);
